export enum AdminViewType {
  LICENSE_LOG = "LICENSE_LOG",
  DOWNLOAD_HISTORY = "DOWNLOAD_HISTORY",
  PROJECT_TABLE = "PROJECT_TABLE",
  PRODUCT_MAPPING = "PRODUCT_MAPPING",
  CUSTOMER_TABLE = "CUSTOMER_TABLE",
  RELEASES = "RELEASES",
  PROJECT_ANALYSIS = "PROJECT_ANALYSIS",
  UPDATE_SYNC = "UPDATE_SYNC",
  EXTENDED_PROJECT_TABLE = "EXTENDED_PROJECT_TABLE",
}
